import { useContext, useEffect, useMemo, useState } from 'react';
import SessionConsumptionContext from '../../../../contexts/SessionConsumptionContext';
import SessionConsumptionConsolidatedInformations from './SessionConsumptionConsolidatedInformations';
import SessionConsumptionMonthlyUsage from './SessionConsumptionMonthlyUsage';
import SessionConsumptionDailyUsage from './SessionConsumptionDailyUsage';
import { SessionConsumptionContainer } from '../styles';
import FeatureToggleService from '../../../../services/FeatureToggleService';
import { SESSION_CONSUMPTION_BY_BOT_INFORMATIONS } from '../../../../shared/FeatureToggleKeys';
import React from 'react';

const SessionConsumptionSummaryComponent: React.FC = () => {
  const [showSessionConsumptionMonthlyUsage, setShowSessionConsumptionMonthlyUsage] = useState(false);
  const { tenant, setHeaderContent, content } = useContext(SessionConsumptionContext);

  useEffect(() => {
    setHeaderContent({
      redirect: '/data-consumption',
      text: content.formatString(content.header, tenant.info.name),
    });
    return () => setHeaderContent({ redirect: null });
  }, []);

  useMemo(() => {
    const getData = async () => {
      const showSessionConsumptionMonthlyUsage = await FeatureToggleService.isFeatureToggleEnabled(
        SESSION_CONSUMPTION_BY_BOT_INFORMATIONS,
      );
      setShowSessionConsumptionMonthlyUsage(showSessionConsumptionMonthlyUsage);
    };
    getData();
  }, []);

  return (
    <SessionConsumptionContainer>
      <SessionConsumptionConsolidatedInformations></SessionConsumptionConsolidatedInformations>
      {showSessionConsumptionMonthlyUsage && <SessionConsumptionMonthlyUsage />}
      <SessionConsumptionDailyUsage />
    </SessionConsumptionContainer>
  );
};

export default SessionConsumptionSummaryComponent;
